import styled from 'styled-components';

import { PremiumIcon } from '@genially/icons';

import increaseSpecificity from '../../../style/mixins/increaseSpecificity';

interface IconProps {
  $isPremium?: boolean;
}

export const Icon = styled(PremiumIcon)<IconProps>(
  ({ $isPremium = false, theme: { color, size } }) => ({
    ...increaseSpecificity(
      {
        color: $isPremium
          ? color.content.premium.default()
          : color.content.premium.disabled(),
        height: size.units(2),
        width: size.units(2),
      },
      4,
    ),
  }),
);
